import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconActivityCyclingComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="18.5" cy="17.5" fill="none" r="3.5" />
        <circle cx="5.5" cy="17.5" fill="none" r="3.5" />
        <circle cx="15" cy="5" fill="none" r="1" />
        <path d="M12 17.5V14l-3-3 4-3 2 3h2" fill="none" />
      </svg>
    </SvgIcon>
  );
};

IconActivityCyclingComponent.displayName = 'IconActivityCycling';

const IconActivityCycling = React.memo(IconActivityCyclingComponent);

export default IconActivityCycling;
